<template>
  <i :class="b(mods)" :style="style">
    <slot />
  </i>
</template>

<script src="./scripts.js" />

<style module src="./styles.scss" lang="scss" />
